import { cn } from '@workspace/ui/lib';
import type { ReactNode } from 'react';

interface FormReadOnlyValueProps {
  value?: string | null;
  placeholder?: string;
  startIcon?: ReactNode;
  multiline?: boolean;
  sensitive?: boolean;
  className?: string;
}

function FormReadOnlyValue({
  value,
  placeholder,
  startIcon,
  multiline = false,
  sensitive = false,
  className,
}: FormReadOnlyValueProps) {
  const displayValue = value?.trim();

  return (
    <div
      data-readonly="true"
      className={cn(
        'flex w-full min-w-0 gap-3',
        multiline ? 'min-h-12 items-start rounded-2xl py-2' : 'h-12 items-center rounded-2xl py-2',
        className
      )}
    >
      {startIcon ? <div className="flex shrink-0 items-center">{startIcon}</div> : null}
      <p
        className={cn(
          'min-w-0 text-base leading-5 font-normal',
          displayValue
            ? 'text-neutral-200 dark:text-neutral-100'
            : 'text-grey-700 dark:text-grey-500',
          multiline ? 'whitespace-pre-wrap' : 'truncate',
          sensitive && 'ph-no-capture'
        )}
      >
        {displayValue || placeholder}
      </p>
    </div>
  );
}

export { FormReadOnlyValue };
